import { getPopeProfileData } from "services/services";

export async function fetchLatestPopePray(setPray) {
  try {
    const response = await getPopeProfileData(2);
    const twoLatest = response.data?.filter(p => p?.group !== 'venicreator') || [];
    if (twoLatest[0]) {
      setPray(twoLatest[0]);
    }
  } catch (error) {
    console.log(error);
  }
}
